import $http from '../../utils/http';
// 分时预约
let appointment = '/openscenic/appoint/gov/appoint/oneMachineTube';
let appointmentNEW = '/openscenic/appoint/gov/appoint/statistics';
// let appointmentNEW = '/gov/appoint/statistics';

// 预约总数统计
const queryAppointCount = params => {
  return $http({
    url: appointmentNEW + '/overviewStatistics',
    params
  });
}

// 景区预约情况
const queryScenicAppoint = params => {
  return $http({
    url: appointmentNEW + '/appointOrgDistributionStatistics',
    params
  });
}

// 州市预约情况
const queryCityAppoint = params => {
  return $http({
    url: appointmentNEW + '/appointCityDistributionStatistics',
    params
  });
}

// 未来10天预约情况
const queryPredictAppoint = params => {
  return $http({
    url: appointmentNEW + '/predictAppoint',
    params
  });
}

// 旅行社预约统计分析
const queryTravelAgencyAppoint = params => {
  return $http({
    url: appointmentNEW + '/appointTravelAgentDistributionStatistics',
    params
  });
}

// 搜索景区和旅行社接口
const queryOrgAndTravelAgencyList = params => {
  return $http({
    url: appointmentNEW + '/orgAndTravelAgencyList',
    params
  });
}


/** 游客信息列表接口 */
/** 入园预约单列表接口 */
const inParkTravel = params => {
  return $http({
    url: appointmentNEW + '/appointList',
    params
  });
}

/** 预约单详细信息 */
const appointInfo = params => {
  return $http({
    url: appointmentNEW + '/appointInfo',
    params
  });
}

/** 机构树和景区接口 */
const city = params => {
  return $http({
    url: appointmentNEW + '/getCity',
    params
  });
}

/** 获取景区 */
const scenic = params => {
  return $http({
    url: appointmentNEW + '/getOrg',
    params
  });
}

/** 预约单旅行社接口 */
const travelAgencyList = params => {
  return $http({
    url: appointmentNEW + '/travelAgencyList',
    params
  });
}

/** 预约单景区接口 */
const orgList = params => {
  return $http({
    url: appointment + '/orgList',
    params
  });
}

export default {
  queryCityAppoint,
  queryScenicAppoint,
  queryAppointCount,
  queryPredictAppoint,
  queryTravelAgencyAppoint,
  queryOrgAndTravelAgencyList,
  inParkTravel,
  appointInfo,
  city,
  scenic,
  travelAgencyList,
  orgList
}
